import * as toastr from "toastr";

class ToastNotification {
    constructor(public notificationKind: ToastNotificationKind, public title: string, public message: string, public timeOut: number = 6000, public showDuplicates: boolean = false) { }

    public show(): void {
        const settings: ToastrOptions = {
            progressBar: true,
            newestOnTop: true,
            positionClass: "toast-top-right",
            preventDuplicates: (this.notificationKind == ToastNotificationKind.Error && !this.showDuplicates ? true : false),
            timeOut: this.timeOut
        };
        switch (this.notificationKind) {
        case ToastNotificationKind.Info:
            toastr.info(this.message, this.title, settings);
            break;
        case ToastNotificationKind.Success:
            toastr.success(this.message, this.title, settings);
            break;
        case ToastNotificationKind.Warning:
            toastr.warning(this.message, this.title, settings);
            break;
        case ToastNotificationKind.Error:
            toastr.error(this.message, this.title, settings);
            break;
        }
    }

    public showWithClose(): void {
        const settings: ToastrOptions = {
            progressBar: true,
            newestOnTop: true,
            positionClass: "toast-top-right",
            closeButton: true,
            timeOut: 0,
            extendedTimeOut: 0
        };
        switch (this.notificationKind) {
            case ToastNotificationKind.Info:
                toastr.info(this.message, this.title, settings);
                break;
            case ToastNotificationKind.Success:
                toastr.success(this.message, this.title, settings);
                break;
            case ToastNotificationKind.Warning:
                toastr.warning(this.message, this.title, settings);
                break;
            case ToastNotificationKind.Error:
                toastr.error(this.message, this.title, settings);
                break;
        }
    }

}

enum ToastNotificationKind {
    Info = 0,
    Success = 1,
    Warning = 2,
    Error = 3
}

export { ToastNotificationKind, ToastNotification };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/ViewModels/toastnotification.ts